import React, { useEffect, useRef } from "react";
import { useFormik } from "formik";
import { DadosFormularioAutorizado, FiltroDefinirAutorizado, ListaAutorizado } from "app/types/Autorizado";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";

const estiloAutorizado = require("./autorizado.module.scss").default;

export type AutorizadoProps = {
    dadosAutorizado: DadosFormularioAutorizado;
    listaAutorizado: ListaAutorizado
    permitirVisualizarBotaoDefinir: boolean;
    onPesquisar: (nome: string) => void;
    onPesquisarPorPagina: (nome: string, numeroPagina: number) => void
    onDefinir: (filtroDefinirAutorizado: FiltroDefinirAutorizado) => void;
    onDefinirAutorizado: (filtroDefinirAutorizado: FiltroDefinirAutorizado) => void
    onSenhaModificada: (senha: string) => void
    onAutorizadoModificado: (autorizado: string) => void
    onObservacaoModificada: (Observacao: string) => void
    senhaPreenchida: boolean
    somenteLeitura: boolean
}

const AutorizadoComponent = (props: AutorizadoProps) => {
    const formik = useFormik({
        initialValues: { ...props.dadosAutorizado },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });

    const senhaRef = useRef<HTMLInputElement>(null);
    const jaFocouSenha = useRef(false);

    // autoFocus nativo é frágil aqui: se o campo estiver disabled no primeiro
    // commit (props.somenteLeitura ainda não resolvido), o navegador ignora o
    // foco e ele nunca mais é aplicado. Foca manualmente assim que habilitado.
    useEffect(() => {
        if (!props.somenteLeitura && !jaFocouSenha.current && senhaRef.current) {
            senhaRef.current.focus();
            jaFocouSenha.current = true;
        }
    }, [props.somenteLeitura]);

    const botaoDefinir =
        <button
            id="Autorizado_BotaoDefinir"
            onClick={() =>
                props.onDefinir({
                    CodigoAutorizado: null,
                    Senha: formik.values.Senha,
                    Observacao: formik.values.Observacao,
                })
            }
            className={`${estiloAutorizado.button} no-global-button`}
        >
            Definir
        </button>

    const botaoPesquisar =
        <button
            id="Autorizado_BotaoPesquisar"
            onClick={() => props.onPesquisar(formik.values.NomeAutorizado)}
            className={`${estiloAutorizado.button} no-global-button`}
        >
            Pesquisar
        </button> 

    return (
        <>
            <div className={`_mt-2 ${estiloAutorizado.form}`}
                id="Autorizado_Formulario"
            >
                <label >Senha</label>
                <input name="Senha" 
                    autoComplete="off"
                    aria-autocomplete="none"
                    list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                    value={formik.values?.Senha ?? ""} 
                    type="password" 
                    onChange={formik.handleChange}
                    id="Autorizado_campoSenha"
                    ref={senhaRef}
                    disabled={props.somenteLeitura} onBlur={(e) => {
                        props.onSenhaModificada(e.target.value)
                        e.target.value && formik.setFieldValue("NomeAutorizado", "")
                    }}></input>
                <label>Autorizado</label>
                <input 
                    name="NomeAutorizado" 
                    autoComplete="off" 
                    value={formik.values?.NomeAutorizado ?? ""} 
                    onChange={formik.handleChange} 
                    disabled={props.senhaPreenchida || props.somenteLeitura} 
                    onBlur={(e) => props.onAutorizadoModificado(e.target.value)}
                    id="Autorizado_campoNomeAutorizado"
                ></input>
                <label>Observação</label>
                <textarea 
                    name="Observacao" 
                    id="Autorizado_campoObservacao"
                    rows={3} 
                    maxLength={254} 
                    value={formik.values?.Observacao ?? ""} 
                    onChange={formik.handleChange} 
                    disabled={props.somenteLeitura} 
                    onBlur={(e) => props.onObservacaoModificada(e.target.value)}
                ></textarea>
            </div>

            {!props.senhaPreenchida && !props.somenteLeitura && botaoPesquisar}
            {props.senhaPreenchida && props.permitirVisualizarBotaoDefinir && !props.somenteLeitura && botaoDefinir}

            {props.listaAutorizado?.Entities?.length > 1 && (
                <div className={`_table _w-full _border-collapse ${estiloAutorizado.tabelaAutorizado}`}
                    id="Autorizado_TabelaAutorizado"
                >
                    <div className="_table-header-group "
                        id="Autorizado_TabelaAutorizado_Cabecalho"
                    >
                        <div className="_table-row"
                            id="Autorizado_TabelaAutorizado_Cabecalho_Linha"
                        >
                            <div className={`_table-cell _font-bold ${estiloAutorizado.tableCellHeader}`}>
                                Nome
                            </div>
                        </div>
                    </div>

                    <div className="_table-row-group">
                        {props.listaAutorizado?.Entities?.map((value) => (
                            <div 
                                key={value.Codigo} 
                                className={`_table-row _cursor-pointer ${estiloAutorizado.linha}`} 
                                id={`Autorizado_TabelaAutorizado_Linha_${value.Codigo}`}
                                onClick={() => props.onDefinirAutorizado({
                                CodigoAutorizado: value.Codigo
                            })}>
                                <div className={`_table-cell ${estiloAutorizado.tableCellBody}`}
                                    id={`Autorizado_TabelaAutorizado_Linha_${value.Codigo}_Celula_Nome`}
                                >
                                    {value.Nome}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {props.listaAutorizado?.Entities?.length > 0 && (
                <Paginacao
                    paginaAtual={props.listaAutorizado?.ActualPage}
                    totalPaginas={props.listaAutorizado?.PageCount}
                    id="Autorizado_Paginacao"
                    onAlterarListaSelecionada={(numeroPagina) => props.onPesquisarPorPagina(formik.values.NomeAutorizado, numeroPagina)}
                />
            )}

        </>
    );
}

export const Autorizado = React.memo(AutorizadoComponent);
